import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import axios from '../../../api/axios';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

function EditDislikesDialog({ open, onClose, onSave, initialDislikes, userId }) {
    const [dislikes, setDislikes] = useState(initialDislikes);
    const [ingredients, setIngredients] = useState([]);
    const [filteredIngredients, setFilteredIngredients] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchIngredients = async () => {
            try {
                const response = await axios.get('/ingredient/list');
                const ingredientNames = response.data.map((ingredient) => ingredient.name) || [];
                setIngredients(ingredientNames);
                setFilteredIngredients(ingredientNames);
            } catch (error) {
                console.error('Error fetching ingredients:', error);
            }
        };

        if (open) {
            fetchIngredients();
        }
    }, [open]);

    useEffect(() => {
        setFilteredIngredients(
            ingredients.filter((ingredient) =>
                ingredient.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery, ingredients]);

    const handleChipClick = (ingredient) => {
        setDislikes((prev) =>
            prev.includes(ingredient)
                ? prev.filter((item) => item !== ingredient)
                : [...prev, ingredient]
        );
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            await axios.post('/user/update/dislikes/', {
                user_id: userId,
                dislikes,
            });
            onSave(dislikes);
        } catch (error) {
            console.error('Error saving dislikes:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{ '& .MuiDialog-paper': { minHeight: '300px', minWidth: '500px' } }}
        >
            <DialogTitle>Edit Dislikes</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    placeholder="Search ingredients"
                    variant="outlined"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    sx={{ mb: 2 }}
                />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
                    {filteredIngredients.map((ingredient) => (
                        <Chip
                            key={ingredient}
                            label={ingredient}
                            color={dislikes.includes(ingredient) ? 'primary' : 'default'}
                            onClick={() => handleChipClick(ingredient)}
                            clickable
                        />
                    ))}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary" disabled={loading}>Cancel</Button>
                <Button onClick={handleSave} color="primary" disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EditDislikesDialog;
